import '../shared/index';
import './components';
import './stores';
import { makeCarousel } from '../../auto/utils/carousel/splide';
import { makeAllDdmOffersListSyncService } from '../../auto/services/DdmServiceV2/makeAllDdmOffersListSyncService';
import { DDMAdapter } from '../../auto/services/ddm_service/adapters/ddmAdapter';
import fcaServiceApi from '../../auto/utils/fcaServiceApi';
import railsDateToChronometer from '../../auto/utils/railsDateToChronometer';
import isMobile from '../../auto/utils/isMobile';

window.makeCarousel = makeCarousel;
window.railsDateToChronometer = railsDateToChronometer;
window.isMobile = isMobile;

window.DDMAdapter = DDMAdapter;
window.serviceFca = fcaServiceApi;
window.ddmOffersListSyncService = makeAllDdmOffersListSyncService();
